/* ============
 * Transfer Index
 * ============
 *
 * This page shows the list of transfers.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import transferService from './../../../../services/transfer';
import accountService from './../../../../services/account';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';
import store from './../../../../store';
import BridgeHandoffMixin from './../../../../mixins/bridgeHandoff';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      info: 'info',
      primary: 'primary',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      transfers: 'paginateTransfers',
      view: 'getView',
    }),

    transfersListView() {
      return this.transfers.items.map(c => ({
        warehouse: c.toWarehouseName,
        status: c.status,
        createdAt: c.createdAt,
        comments: c.comments,
        id: c.id,
      }));
    },

    transfersList() {
      return this.transfers.items.map(b => b);
    },
  },

  watch: {

    transfers(transfers) {
    },

    view(view) {
      if (view == 'card') {
        this.info = 'info';
        this.primary = 'primary';
      } else {
        this.primary = 'info';
        this.info = 'primary';
      }
    },
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, this.limit);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },

  mixins: [
    SearchMixin,
    BridgeHandoffMixin,
  ],

  mounted() {
    this.setInnerSidebar([{
      title: this.$t('static.inventory.transaction.title'),
      options: [{
        title: this.$t('static.stock.filters.title'),
        route: {
          name: 'inventory.stock.index',
        },
      },
      {
        title: this.$t('static.adjustment.filters.title'),
        route: {
          name: 'inventory.adjustment.index',
        },
      },
      {
        title: this.$t('static.purchase.filters.title'),
        route: {
          name: 'inventory.purchase.index',
        },
      },
      {
        title: this.$t('static.transfer.filters.title'),
        route: {
          name: 'inventory.transfer.index',
        },
      },
      ],
      button: this.bridgeStockWriteBlocked ? null : {
        title: `+ ${this.$t('static.warehouse.addTransaction.title')}`,
        route: {
          name: 'inventory.transaction.index',
        },
      },
    },

    {
      title: this.$t('static.warehouse.filters.title'),
      options: [{
        title: this.$t('static.warehouse.filters.view'),
        route: {
          name: 'warehouse.index',
        },
      },
      ],
      button: {
        title: `+ ${this.$t('static.warehouse.create.title')}`,
        route: {
          name: 'warehouse.create',
        },
      },
    },
    ]);

    accountService.rememberPerPage('get', { from: 'transfer' })
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });

    if (this.view == 'card') {
      this.info = 'info';
      this.primary = 'primary';
    } else {
      this.primary = 'info';
      this.info = 'primary';
    }
  },

  destroyed() {
    // this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    formatDate(value, pattern = 'DD-MM-YYYY') {
      if (!value) {
        return '-';
      }
      const m = moment(value);
      return m.isValid() ? m.format(pattern) : '-';
    },

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'transfer', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated transfer.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function (page, limit) {
      this.loading = true;
      transferService.items({
        page,
        limit,
        search: this.getSearch(this.limit),
        filter: this.$route.query.filter,
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loadProductsing = false;
      });
    }, 800),

    changeView(view) {
      if (this.info != view) {
        this.primary = this.info;
        this.info = view;
        if (this.info == 'info') {
          store.dispatch('setView', 'card');
        } else {
          store.dispatch('setView', 'list');
        }
      }
    },
    /**
     * Go to view the for transfer.
     *
     * @param  {Object} transfer The transfer object.
     */
    viewTransfer(transfer) {
      this.$router.push({
        name: 'inventory.transfer.view',
        params: { id: transfer.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/transfer/index/index.js